export const SET_STATE = 'checkoutPage/insurances/SET_STATE';
export const REQUEST_INSURANCES = 'checkoutPage/insurances/REQUEST_INSURANCES';
export const SET_INSURANCES = 'checkoutPage/insurances/SET_INSURANCES';
export const SET_CURRENT_TOKENS = 'checkoutPage/insurances/SET_CURRENT_TOKENS';
export const SET_VALIDITY = 'checkoutPage/insurances/SET_VALIDITY';
export const RESET_INSURANCES = 'checkoutPage/insurances/RESET_INSURANCES';
